import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

const SLICE_NAME = 'dealers/views/.components/deleteWebHook/redux';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    dealerId: null,
    webhook: null,
    error: null,
};

export const deleteDealerWebhook = createAsyncThunk(
    `${SLICE_NAME}/deleteDealerWebhook`,
    async (payload, { rejectWithValue }) => {
        try {
            const { dealerId, id } = payload;

            const response = await clientMutation(
                `mutation deleteDealerWebhook($dealerId: Int!, $id: Int!) {
                    result: deleteDealerWebhook(dealerId: $dealerId, id: $id)
                }`,
                { dealerId, id },
                endpoints.GRAPHQL_GENERAL
            );

            return { success: response?.result === true };
        } catch (exc) {
            ExceptionManager(exc, `${SLICE_NAME}/deleteDealerWebhook`, 'deleteDealerWebhook');
            return rejectWithValue(exc.message || 'Failed to delete webhook');
        }
    }
);

export const deleteWebHookSlice = createSlice({
    name: SLICE_NAME,
    initialState: INIT_STATE,
    reducers: {
        openModalDeleteWebHook(state, action) {
            state.openModal = true;
            state.dealerId = action.payload?.dealerId || null;
            state.webhook = action.payload?.webhook || null;
            state.error = null;
            state.result = null;
        },
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteDealerWebhook.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteDealerWebhook.fulfilled, (state, action) => {
                state.loading = false;
                state.result = action.payload;
            })
            .addCase(deleteDealerWebhook.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { openModalDeleteWebHook, reset } = deleteWebHookSlice.actions;
export default deleteWebHookSlice.reducer;
